import React, { useState, useEffect } from "react";
import { Menu, X, ArrowRight, Zap } from "lucide-react";
import { navLinks, SHOP_URL } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0e0e10]/90 backdrop-blur-md border-b border-white/5 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2 group">
          <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-[#f15a24] shadow-lg shadow-[#f15a24]/30">
            <Zap size={20} className="text-white" fill="white" />
          </span>
          <span className="font-display font-bold text-white text-xl tracking-tight">
            Posi<span className="text-[#f15a24]">-Products</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className="px-4 py-2 text-sm font-medium text-neutral-300 hover:text-white rounded-full transition-colors duration-200 hover:bg-white/5"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:block">
          <a
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 bg-[#f15a24] hover:bg-[#ff6a34] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-300 shadow-lg shadow-[#f15a24]/25 hover:shadow-[#f15a24]/40"
          >
            Shop Now
            <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" />
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-[#0e0e10]/98 backdrop-blur-md border-t border-white/5 mt-3 px-6 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noopener noreferrer" : undefined}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-neutral-200 hover:text-[#f15a24] border-b border-white/5 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center justify-center gap-2 bg-[#f15a24] text-white font-semibold px-5 py-3 rounded-full"
            >
              Shop Now <ArrowRight size={16} />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
